import { Flex } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";

import { useSidebarNavigationEntities } from "hooks/useNavigationEntities";
import NavigationLinkItem from "@features/services/NavigationLinkItem";

const NavigationLinks = () => {
  const { root, byId } = useSidebarNavigationEntities();
  return (
    <Flex flexDirection="row" gap={4}>
      {root.children.map((child) => {
        const entity = byId[child.id];
        return <NavigationLinkItem key={entity.id} entity={entity} />;
      })}
    </Flex>
  );
};

export default observer(NavigationLinks);
